import { usePersistedQueryParams } from '@plato/app-shared/hooks/use-persisted-query-params';
import {
    jsonParam,
    queryParamsConfig,
    stringArrayParam,
    stringParam,
    transientParam,
} from '@plato/ui-legacy/lib/query-params';
import type { SalesDraftSort, SalesDraftState } from '../../../server/types/drafts-types.ts';
import type { RouterInput } from '../../../server/types/infer-trpc-types.ts';

export type DraftListQueryFilters = Pick<
    RouterInput['platoUser']['query']['salesDraft']['getSalesDraftList']['getWithFilters'],
    'customers' | 'users' | 'states' | 'search_query' | 'sort'
>;

const config = queryParamsConfig<DraftListQueryFilters>({
    customers: stringArrayParam(),
    users: stringArrayParam(),
    search_query: transientParam(stringParam()),
    states: stringArrayParam(),
    sort: jsonParam<SalesDraftSort>(),
});

export const defaultDraftFilters = {
    customers: [] as string[],
    users: [] as string[],
    search_query: '' as string,
    states: [] as SalesDraftState[],
} satisfies DraftListQueryFilters;

export function useDraftListAppliedFilters() {
    return usePersistedQueryParams(config, defaultDraftFilters, 'drafts');
}
